import { isValidEmailAddress, fadeOutNotifications } from '../functions';

$(document).ready(function() {
	$("#search-btn").click(function(){
		var url = $("#s-query").data('url');

        var term = $("#s-query").val();
        if(term != ""){
            window.location = url + '?q=' + term;
        }

    });

    $("#s-query").keypress(function(e){
        if(e.which == 13) {
			var url = $("#s-query").data('url');
            var term = $(this).val();
            if(term != ""){
                window.location = url + '?q=' + term;
            }
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/search.js